import {KTSVG} from '../../../../_metronic/helpers'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import React, {useEffect, useState} from 'react'
import {
  createClientDemandeMessage,
  getClientDemandeMessageByDemandeId,
} from '../../../../components/requests'
import {useFormik} from 'formik'
import {ModeleClientDemandeMessage} from '../../../../components/Models'

interface FormValues {
  message: string
}

// Validation du formulaire de message
const validate = (value) => {
  const error: Partial<FormValues> = {}

  if (!value.message) {
    // Si le message est null
    error.message = 'Le message est requis'
  } else if (value.message.trim().length === 0) {
    // Si le message est une chaine de caractère vide
    error.message = 'Veuillez écrire un message valide'
  }

  return error
}

interface ClientDemandeMessageProps {
  demandeId: any
  clientId?: any
  demontage?: any
  readOnly?: any
  trigger?: any
}

const ClientDemandeMessage: React.FC<ClientDemandeMessageProps> = ({
  demandeId,
  demontage = null,
  readOnly = false,
  trigger = 0,
  clientId,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [spinner, setSpinner] = useState<boolean>(false)
  const [messages, setMessages] = useState<Array<ModeleClientDemandeMessage>>([])
  const [comments, setComments] = useState<any>()

  const toggleChat = () => {
    if (demontage) {
      setComments(demontage)
    }
    setIsOpen((prev) => !prev)
    formik.resetForm()
  }

  // Retourne un tableau de message sur la demande concernée
  const getClientDemandeMessage = (signal) => {
    getClientDemandeMessageByDemandeId(demandeId, signal)
      .then((response) => {
        if (response?.status === 200 && response?.data !== null) {
          if (demandeId) {
            setMessages(response?.data)
          }
        }
      })
      .catch(() => {
        console.log('error')
      })
  }

  const formik = useFormik({
    initialValues: {
      message: '',
    },
    validate,
    onSubmit: (value) => {
      submitMessage(demandeId, value.message.trim(), clientId)
    },
  })

  const submitMessage = (demandeId, message, clientId) => {
    setSpinner(true)
    // Création du toast de loading sur le container qui a l'Id "messageToastContainerId"
    createClientDemandeMessage(demandeId, message, clientId)
      .then((response) => {
        if (response?.data !== null && response?.status === 200) {
          // Si la requête est OK,
          // Ajout du message ajouté dans le tableau de message initial
          setMessages((prevMessages) => {
            return [
              ...prevMessages,
              {
                ...response?.data,
                client:
                  response?.data?.demande?.client?.nom +
                  ' ' +
                  response?.data?.demande?.client?.prenom,
              },
            ]
          })
          // Desactiver le spinner
          setSpinner(false)
        }
      })
      .catch(() => {
        // Si il y a une erreur
        console.log('error')
      })
      .finally(() => {
        // Que la requête soit OK ou non,
        // Desactiver le spinner
        setSpinner(false)
        // Reinitialiser le formulaire
        formik.resetForm()
      })
  }

  // Chargement des messages sur la demande
  useEffect(() => {
    if (demandeId) {
      const controller = new AbortController()
      const signal = controller.signal
      getClientDemandeMessage(signal)
      return () => controller.abort()
    }
  }, [])

  // Chargement des messages sur la demande quand la liste de demande se recharge automatiquement
  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    if (trigger > 0) {
      getClientDemandeMessage(signal)
    }

    return () => controller.abort()
  }, [trigger])

  const convertDate = (date) => {
    let dateConvert = ''
    if (date) {
      dateConvert = new Date(date).toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    }
    return dateConvert
  }

  return (
    <>
      {isOpen && (
        <div
          className='card shadow-lg position-fixed'
          style={{
            bottom: '80px',
            right: '20px',
            width: '320px',
            height: '420px',
            zIndex: 106, //105 pour l'icône scrolltoptop
          }}
        >
          <div className='card-header d-flex justify-content-between align-items-center px-5 min-h-55px'>
            <h6 className='mb-0'>{demontage ? 'Commentaire' : 'Messages'}</h6>
            <button
              className='btn btn-sm btn-icon btn-light'
              onClick={toggleChat}
              aria-label='Fermer'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </button>
          </div>

          {messages.length > 0 ? (
            <div className='card-body overflow-auto px-5'>
              {messages.map((item, index) => (
                <div key={index} className='d-flex'>
                  <div className='bg-light rounded px-3 py-2 mb-2 w-100'>
                    <div
                      className='d-flex justify-content-between text-muted mb-1'
                      style={{fontSize: '0.75rem'}}
                    >
                      <strong>{item.client ?? ''}</strong>
                      <span>{item.dateCreation && convertDate(item?.dateCreation)}</span>
                    </div>
                    {item.dateLecture ? (
                      <div
                        className='d-flex flex-column text-muted mb-1'
                        style={{fontSize: '0.75rem'}}
                      >
                        <strong>Lu par : {item.luPar ?? ''}</strong>
                        <span>
                          Date lecture : {item.dateLecture && convertDate(item?.dateLecture)}
                        </span>
                      </div>
                    ) : (
                      <div
                        className='d-flex flex-row text-muted gap-2 mb-1'
                        style={{fontSize: '0.75rem'}}
                      >
                        <strong>Statut : </strong>
                        <span className='text-danger'> Non lu </span>
                      </div>
                    )}
                    <div style={{whiteSpace: 'pre-line'}}>
                      {item.message.replace(/\n{3,}/g, '\n\n')}
                    </div>
                  </div>
                </div>
              ))}
              {/*)}*/}
            </div>
          ) : demandeId !== null ? (
            <span className='text-muted d-grid justify-content-center align-items-center h-100'>
              Aucun message pour le moment.
            </span>
          ) : (
            ''
          )}

          {comments && (
            <div className='card-body overflow-auto px-5'>
              <>
                {comments?.commentaire && (
                  <div>
                    <div className='bg-light rounded px-3 py-2 mb-2 w-100'>
                      {/*<span style={{fontSize: '0.75rem'}}>Création :</span>*/}
                      <div
                        className='d-flex justify-content-between text-muted mb-1'
                        style={{fontSize: '0.75rem'}}
                      >
                        <div className='d-flex'>
                          <i className='bi bi-c-circle fs-5 pe-1'></i>
                          <strong>
                            {comments?.demandePar?.nom + ' ' + comments?.demandePar?.prenom}
                          </strong>
                        </div>
                        <div>
                          <span>{convertDate(comments?.dateCreation)}</span>
                        </div>
                      </div>
                      <div style={{whiteSpace: 'pre-line'}}>
                        {comments?.commentaire.replace(/\n{3,}/g, '\n\n')}
                      </div>
                    </div>
                  </div>
                )}
                {comments?.commentaireValidation && (
                  <div>
                    <div className='bg-light rounded px-3 py-2 mb-2 w-100'>
                      <div
                        className='d-flex justify-content-between text-muted mb-1'
                        style={{fontSize: '0.75rem'}}
                      >
                        <div className='d-flex gap-1'>
                          {comments?.statut?.code === 'VALIDE' ? (
                            <i className='bi bi-check-circle fs-5 pe-1'></i>
                          ) : (
                            <i className='bi bi-x-circle'></i>
                          )}
                          <strong>
                            {comments?.validePar?.nom} {comments?.validePar?.prenom}
                          </strong>
                        </div>
                        <div className='text-end'>
                          <span>{convertDate(comments?.dateValidation)}</span>
                        </div>
                      </div>
                      <div style={{whiteSpace: 'pre-line'}}>
                        {comments.commentaireValidation.replace(/\n{3,}/g, '\n\n')}
                      </div>
                    </div>
                  </div>
                )}
                {comments?.commentaireModification && (
                  <div>
                    <div className='bg-light rounded px-3 py-2 mb-2 w-100'>
                      <div
                        className='d-flex justify-content-between text-muted mb-1'
                        style={{fontSize: '0.75rem'}}
                      >
                        <div className='d-flex gap-1'>
                          <i className='bi bi-pencil-square'></i>
                          <strong>
                            {comments?.demandePar?.nom} {comments?.demandePar?.prenom}
                          </strong>
                        </div>
                        <div className='text-end'>
                          <span>{convertDate(comments?.dateModification)}</span>
                        </div>
                      </div>
                      <div style={{whiteSpace: 'pre-line'}}>
                        {comments.commentaireModification.replace(/\n{3,}/g, '\n\n')}
                      </div>
                    </div>
                  </div>
                )}
                {comments?.commentaireAnnulation && (
                  <div>
                    <div className='bg-light rounded px-3 py-2 mb-2 w-100'>
                      <div
                        className='d-flex justify-content-between text-muted mb-1'
                        style={{fontSize: '0.75rem'}}
                      >
                        <div className='d-flex gap-1'>
                          <i className='bi bi-x-square'></i>
                          <strong>
                            {comments?.demandePar?.nom} {comments?.demandePar?.prenom}
                          </strong>
                        </div>
                        <div className='text-end'>
                          <span>{convertDate(comments?.dateAnnulation)}</span>
                        </div>
                      </div>
                      <div style={{whiteSpace: 'pre-line'}}>
                        {comments.commentaireAnnulation.replace(/\n{3,}/g, '\n\n')}
                      </div>
                    </div>
                  </div>
                )}
                {!comments?.commentaire &&
                  !comments?.commentaireValidation &&
                  !comments?.commentaireModification &&
                  !comments?.commentaireAnnulation && (
                    <span className='text-muted d-grid justify-content-center align-items-center h-100'>
                      Aucun commentaire disponible.
                    </span>
                  )}
              </>
            </div>
          )}

          {!readOnly && demandeId !== null && (
            <div className='card-footer px-5 py-4'>
              <form className='d-flex align-items-center gap-2' onSubmit={formik.handleSubmit}>
                <textarea
                  id='message'
                  name='message'
                  className='form-control form-control-flush'
                  placeholder='Écrire votre message...'
                  style={{height: '45px'}}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.message}
                ></textarea>
                <button
                  type='submit'
                  className='btn btn-icon btn-primary w-45px h-40px'
                  disabled={spinner || !formik.values.message.trim()}
                  aria-label='Envoyer'
                >
                  {spinner ? (
                    <span className='spinner-border spinner-border-sm align-middle'></span>
                  ) : (
                    <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-2' />
                  )}
                </button>
              </form>
            </div>
          )}
        </div>
      )}

      {!readOnly ? (
        <OverlayTrigger
          placement='left'
          // delay={{show: 250, hide: 400}}
          overlay={
            <Tooltip id='tooltip-message'>{demontage ? 'Commentaire...' : 'Messages...'}</Tooltip>
          }
        >
          <button
            className='btn btn-icon btn-primary shadow position-fixed'
            style={{
              zIndex: isOpen ? 0 : 1050,
              padding: 0,
              transition: 'bottom 0.3s ease-in-out',
              bottom: '30px',
              right: '20px',
              width: '36px',
              height: '36px',
            }}
            onClick={toggleChat}
          >
            <KTSVG path='/media/icons/duotune/communication/com012.svg' className='svg-icon-1' />
          </button>
        </OverlayTrigger>
      ) : (
        <div
          className='btn btn-icon btn-light-primary btn-sm position-relative'
          data-tooltip-id='tooltip'
          data-tooltip-content={demontage ? 'Commentaire' : 'Message'}
          data-tooltip-place='left'
          onClick={toggleChat}
        >
          <KTSVG path='/media/icons/duotune/communication/com012.svg' className='svg-icon-1' />
          {messages.length !== 0 && (
            <span className='position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-white'>
              <span style={{paddingTop: '1px'}}>{messages.length}</span>
            </span>
          )}
        </div>
      )}
    </>
  )
}

export default ClientDemandeMessage
